// extracted by mini-css-extract-plugin
export default {"root":"H3_root__W9ZFm","inverted":"H3_inverted__4SVqV","left":"H3_left__DsX6R","center":"H3_center__zPM80"};